import React, { useEffect } from 'react';
import { X, CheckCircle2, AlertCircle, Info } from 'lucide-react';
import { cn } from '../../lib/utils';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
 useEffect(() => {
 if (duration > 0) {
 const timer = setTimeout(() => {
 onClose();
 }, duration);
 return () => clearTimeout(timer);
 }
 }, [duration, onClose]);

 const icons = {
 success: CheckCircle2,
 error: AlertCircle,
 info: Info,
 };

 const styles = {
 success: 'bg-success/15 border-success/40 text-success',
 error: 'bg-destructive/15 border-destructive/40 text-destructive',
 info: 'bg-accent border-border text-foreground',
 };

 const Icon = icons[type] || CheckCircle2;

 return (
 <div
 className={cn(
 'fixed bottom-4 left-3 z-[60]',
 'flex items-center gap-2 px-3 py-2 border max-w-[200px]',
 'toast-animate',
 styles[type]
 )}
 >
 <Icon className="h-4 w-4 flex-shrink-0" />
 <p className="text-sm font-medium">{message}</p>
 <button
 onClick={onClose}
 className="ml-1 text-current opacity-60 hover:opacity-100 transition-opacity flex-shrink-0"
 >
 <X className="h-3.5 w-3.5" />
 </button>
 </div>
 );
};

export default Toast;
